export const CHANGE_FACEBOOK_TOKEN = "CHANGE_FACEBOOK_TOKEN";

export interface FacebookAction {
  type: string;
  token: string;
  expiresAt: number;
}

export interface FacebookState {
  token: string;
  expiresAt: number;
}



// WEBPACK FOOTER //
// ./src/store/facebook/types.ts